import type { TermsContent } from "./types";

export const termsZhHant: TermsContent = {
  locale: "zh-Hant",
  seo: {
    title: "使用條款 - Prismark",
    description: "Prismark 使用條款，說明產品使用規則、使用者內容、權限、免責聲明及聯絡方式。"
  },
  title: "使用條款",
  updated: "最後更新：2026 年 9 月 13 日",
  intro: [
    "歡迎使用 Prismark。請在使用 Prismark 前仔細閱讀本使用條款。你下載、安裝、存取或使用 Prismark，即表示你已閱讀、理解並同意受本條款約束。",
    "如果你不同意本條款中的任何內容，請停止使用 Prismark。"
  ],
  sections: [
    {
      title: "1. 關於 Prismark",
      body: [
        "Prismark 是一款適用於 iOS 的輕量而專業的相機 App，用於拍照、影片錄製、雙鏡頭錄影、相簿回看以及相關拍攝輔助功能。",
        "Prismark 旨在提供輕量而專業的拍攝體驗。部分功能可能會受到裝置型號、iOS 版本、系統權限、硬體能力或地區設定的影響。"
      ]
    },
    {
      title: "2. 使用規則",
      body: ["你應以合法、合理、尊重他人權益的方式使用 Prismark。", "你不得使用 Prismark 從事以下行為："],
      bullets: [
        "侵犯他人隱私、肖像權、名譽權、智慧財產權或其他合法權益；",
        "在未取得必要授權或同意的情況下拍攝、錄製或傳播他人影像、聲音或相關內容；",
        "用於偷拍、騷擾、跟蹤、恐嚇、詐欺或其他違法、侵權、不當用途；",
        "干擾、破壞或試圖繞過 Prismark 的正常功能、安全機制或技術限制；",
        "違反適用法律法規、平台規則或 App Store 相關規定的行為。"
      ]
    },
    {
      title: "3. 使用者內容",
      body: [
        "你透過 Prismark 拍攝、錄製、儲存或管理的照片、影片及其他內容，歸你或相關權利人所有。",
        "Prismark 不主張擁有你透過本 App 建立的照片、影片或其他使用者內容的所有權。",
        "你理解並同意，你應對自己拍攝、儲存、分享、發布或以其他方式使用相關內容的行為承擔責任。你應確保相關內容的取得、使用和傳播不侵犯任何第三方權益，也不違反適用法律法規。"
      ]
    },
    {
      title: "4. 權限與裝置取用",
      body: ["為了提供核心功能，Prismark 可能會請求取用你的相機、麥克風、照片圖庫或其他必要的系統權限。", "這些權限主要用於："],
      bullets: [
        "使用相機進行拍照或影片錄製；",
        "使用麥克風錄製影片聲音；",
        "儲存照片或影片到系統相簿；",
        "從相簿中查看、選擇或管理相關媒體內容。"
      ]
    },
    {
      title: "5. 功能可用性",
      body: [
        "Prismark 會盡力保持功能穩定、體驗流暢，但我們不保證所有功能在所有裝置、系統版本或使用環境下都始終可用。",
        "部分功能，尤其是雙鏡頭錄影、HDR 影片、特定拍攝輔助能力或與系統硬體相關的功能，可能會受到裝置型號、iOS 版本、系統權限、硬體能力或系統限制的影響。",
        "我們可能會根據產品規劃、技術限制、系統變化或營運需要，對 Prismark 的功能、介面、內容或服務進行更新、調整、暫停或終止。"
      ]
    },
    {
      title: "6. 付費功能",
      body: [
        "Prismark 不需要帳號和登入。核心相機功能均已包含在內，不額外收費：拍照與錄影、手動曝光參數、內建濾鏡、照片浮水印，以及各項拍攝輔助工具。",
        "其中三項功能屬於 Prismark Pro：匯入你自己的 LUT、ProRAW 與 RAW 輸出、雙鏡頭子母畫面錄影。Prismark Pro 是一次性 App 內購買，並非訂閱，沒有週期扣款，不會自動續訂，也不需要取消。App 本身與 Prismark Pro 的目前價格及可用範圍，均以 App Store 商品頁和 App 內購買前的顯示為準。",
        "Prismark Pro 與購買時使用的 Apple 帳號綁定。在你的其他裝置上，或重新安裝之後，可以用 App 內的「回復購買」取回。如果你在 Prismark 提供付費檔位之前就已下載過本 App，這些功能對你仍然免費。",
        "你應在購買前仔細閱讀相關說明。所有購買和退款通常由 App Store 及 Apple 相關規則處理。"
      ]
    },
    {
      title: "7. 第三方服務",
      body: [
        "Prismark 可能會在必要時使用 iOS 系統能力、App Store 服務、系統相簿、系統分享功能或其他第三方服務。",
        "第三方服務可能會受到其各自條款和隱私權政策約束。我們無法控制第三方服務的內容、規則或可用性，也不對第三方服務導致的問題承擔責任。"
      ]
    },
    {
      title: "8. 智慧財產權",
      body: [
        "Prismark 的名稱、圖示、介面設計、視覺元素、軟體程式碼、文案、頁面內容及相關品牌資產，均受適用的智慧財產權法律保護。",
        "未經我們事先書面許可，你不得複製、修改、散布、出售、出租、還原工程、反編譯、試圖擷取原始碼，或以其他未經授權的方式使用 Prismark 的任何部分。",
        "本條款並未向你轉讓 Prismark 或相關內容的任何所有權。你僅獲得在遵守本條款前提下使用 Prismark 的有限、非專屬、不可轉讓許可。"
      ]
    },
    {
      title: "9. 免責聲明",
      body: [
        "Prismark 按「現狀」和「可用」狀態提供。我們會努力提供穩定、可靠的產品體驗，但不保證 Prismark 完全無錯誤、不中斷、始終安全，或一定滿足你的全部需求。",
        "你理解並同意，使用 Prismark 進行拍攝、錄製、儲存或分享內容時，應自行判斷拍攝環境、裝置狀態、內容合法性和使用風險。",
        "對於因裝置故障、系統限制、權限設定、使用者誤操作、第三方服務、網路環境或其他不可控因素導致的內容遺失、拍攝失敗、功能無法使用或其他損失，我們在適用法律允許的範圍內不承擔責任。"
      ]
    },
    {
      title: "10. 責任限制",
      body: [
        "在適用法律允許的最大範圍內，Prismark 及其開發者、營運者不對任何間接、偶然、特殊、懲罰性或衍生性損失承擔責任，包括但不限於資料遺失、內容損壞、利潤損失、業務中斷或因使用或無法使用 Prismark 而產生的損失。",
        "如果適用法律不允許完全排除或限制某些責任，本條款將在法律允許的最大範圍內適用。"
      ]
    },
    {
      title: "11. 條款變更",
      body: [
        "我們可能會不時更新本使用條款。更新後的條款將發布在 Prismark 官方網站或 App 相關頁面中，並標明更新日期。",
        "如果你在條款更新後繼續使用 Prismark，即表示你接受更新後的條款。若你不同意更新內容，請停止使用 Prismark。"
      ]
    },
    {
      title: "12. 終止",
      body: [
        "如果你違反本條款，或以違法、不當、侵權方式使用 Prismark，我們有權在適用法律允許的範圍內限制、暫停或終止你對 Prismark 的使用。",
        "你也可以隨時停止使用 Prismark，並從裝置中刪除 App。"
      ]
    },
    {
      title: "13. 聯絡我們",
      body: ["如果你對本使用條款有任何問題、意見或請求，可以透過以下方式聯絡我們：", "Email：axqora@gmail.com"]
    }
  ],
  privacyLink: {
    body: "關於 Prismark 如何使用權限和處理資料，請閱讀我們的隱私權政策。",
    label: "隱私權政策",
    href: "/zh-Hant/privacy"
  }
};
